/**
 * @file 文档数量文案组件
 */
import React from 'react';
import { useIntl } from 'umi';

export interface IDocCountTextProps {
  /** 文档数量 */
  count?: number;
}

/** 文档数量文案 */
const DocCountText: React.FC<IDocCountTextProps> = ({ count = 0 }) => {
  const { formatMessage } = useIntl();
  return (
    <span>
      {count} {formatMessage({ id: 'dba_kb_doc_count_unit' })}
    </span>
  );
};

export default DocCountText;
